/* ═══════════════════════════════════════════════════════════════
   LA COMPAGNIE DU CAVIAR — Shopify Theme JS
   Reprend toute la logique du site original + adaptations Shopify
═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ─── CUSTOM CURSOR ─── */
  const cur = document.getElementById('cur');
  const ring = document.getElementById('cur-ring');
  if (cur && ring && !reduced && window.matchMedia('(hover: hover)').matches) {
    let mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', (e) => {
      mx = e.clientX; my = e.clientY;
      cur.style.left = mx + 'px';
      cur.style.top = my + 'px';
    });
    (function animRing() {
      rx += (mx - rx) * .14; ry += (my - ry) * .14;
      ring.style.left = rx + 'px';
      ring.style.top = ry + 'px';
      requestAnimationFrame(animRing);
    })();
    document.querySelectorAll('a, button, .size-btn, .caviar-mini, .auto-card, .bc, .ft-soc').forEach(el => {
      el.addEventListener('mouseenter', () => { cur.classList.add('hov'); ring.classList.add('hov'); });
      el.addEventListener('mouseleave', () => { cur.classList.remove('hov'); ring.classList.remove('hov'); });
    });
  }

  /* ─── NAV STUCK + BACK TO TOP ─── */
  const nav = document.getElementById('nav');
  const topBtn = document.getElementById('top-btn');
  function onScroll() {
    const y = window.scrollY;
    if (nav) nav.classList.toggle('stuck', y > 80);
    if (topBtn) topBtn.classList.toggle('show', y > 500);
    document.body.classList.toggle('is-scrolled', y > 50);
    // Scroll progress
    const sp = document.getElementById('scroll-progress');
    if (sp) {
      const h = document.documentElement;
      const pct = (h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight)) * 100;
      sp.style.transform = 'scaleX(' + (pct / 100) + ')';
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ─── REVEAL ON SCROLL ─── */
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: .15, rootMargin: '0px 0px -50px 0px' });
  document.querySelectorAll('.rv, .rv-l, .rv-r, .rv-s').forEach(el => revealObs.observe(el));

  /* ─── COUNTER ANIM ─── */
  function animateCounter(el) {
    const target = parseInt(el.dataset.count);
    if (isNaN(target)) return;
    let cur = 0;
    const step = Math.max(1, Math.ceil(target / 40));
    const sufEl = el.querySelector('.u');
    const suf = sufEl ? sufEl.textContent : '';
    if (target === 0) { el.innerHTML = '0' + (suf ? '<span class="u">'+suf+'</span>' : ''); return; }
    const t = setInterval(() => {
      cur += step;
      if (cur >= target) { cur = target; clearInterval(t); }
      el.innerHTML = cur + (suf ? '<span class="u">' + suf + '</span>' : '');
    }, 38);
  }
  const countObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        animateCounter(e.target);
        countObs.unobserve(e.target);
      }
    });
  }, { threshold: .5 });
  document.querySelectorAll('[data-count]').forEach(el => countObs.observe(el));

  /* ─── PARALLAX TINS (hero) ─── */
  const heroEl = document.querySelector('.hero');
  const tins = document.querySelectorAll('.hero-float-tin');
  if (heroEl && tins.length && !reduced) {
    heroEl.addEventListener('mousemove', (e) => {
      const r = heroEl.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - .5;
      const py = (e.clientY - r.top) / r.height - .5;
      tins.forEach((t, i) => {
        const s = (i + 1) * 18;
        t.style.transform = `translate(${px * s}px, ${py * s}px)`;
      });
    });
  }

  /* ─── BURGER MENU (mobile) ─── */
  const burger = document.querySelector('.burger');
  if (burger) {
    burger.addEventListener('click', () => {
      document.body.classList.toggle('menu-open');
    });
  }

  /* ─── ACCORDÉON FAQ (questions/réponses) ─── */
  document.querySelectorAll('.accordion-q').forEach(function (q) {
    q.style.cursor = 'pointer';
    q.setAttribute('role', 'button');
    q.setAttribute('tabindex', '0');
    function toggle() {
      var item = q.closest('.accordion-item');
      if (!item) return;
      var willOpen = !item.classList.contains('open');
      // Ferme les autres items du même groupe FAQ (accordéon classique)
      var group = item.parentElement;
      if (group) {
        group.querySelectorAll('.accordion-item.open').forEach(function (other) {
          if (other !== item) other.classList.remove('open');
        });
      }
      item.classList.toggle('open', willOpen);
    }
    q.addEventListener('click', toggle);
    q.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  });

  /* ─── LAZY LOAD IMAGES ─── */
  document.querySelectorAll('img:not([loading])').forEach(img => {
    img.setAttribute('loading', 'lazy');
    img.setAttribute('decoding', 'async');
  });

  /* ─── SMOOTH ANCHOR SCROLL ─── */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    const href = a.getAttribute('href');
    if (!href || href === '#' || href.length < 2) return;
    a.addEventListener('click', e => {
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      const offset = 130;
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });
    });
  });

  /* ─── TOAST ─── */
  window.showToast = function(msg) {
    const toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = '✓ ' + msg;
    toast.classList.add('show');
    clearTimeout(window._toastTimer);
    window._toastTimer = setTimeout(() => toast.classList.remove('show'), 2200);
  };

  /* ─── SHOPIFY AJAX ADD-TO-CART ─── */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      if (e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Ajout en cours…'; }
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST', body: fd,
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) throw new Error('add failed');
        const item = await res.json();
        // Refresh cart count
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
        if (window.showToast) window.showToast((item.product_title || 'Produit') + ' ajouté');
        if (btn) { btn.innerHTML = '✓ Ajouté !'; btn.style.background = 'var(--teal)'; }
        setTimeout(() => {
          if (btn) { btn.disabled = false; btn.innerHTML = originalText; btn.style.background = ''; }
        }, 1400);
      } catch (err) {
        if (btn) { btn.disabled = false; btn.innerHTML = originalText; }
        alert('Erreur — réessayez');
      }
    });
  });

})();
